var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14135 0.945574C7.00533 0.951372 6.88734 1.04129 6.84547 1.17111L5.31351 5.92896L0.325857 5.91907C0.184731 5.91884 0.0594883 6.0099 0.0159225 6.14438C-0.0276403 6.27886 0.0202335 6.42619 0.134471 6.50917L4.17594 9.43971L2.62411 14.1926C2.58021 14.3271 2.62797 14.4743 2.74221 14.5575C2.85634 14.6406 3.01096 14.6405 3.12498 14.5572L7.15512 11.61L11.1867 14.5572C11.3007 14.6405 11.4554 14.6405 11.5696 14.5574C11.6837 14.4742 11.7314 14.3268 11.6875 14.1924L10.1356 9.43949L14.1771 6.50894C14.2915 6.42595 14.3395 6.27874 14.2959 6.14415C14.2522 6.00967 14.1271 5.91861 13.9858 5.91895L8.99819 5.92884L7.46452 1.171C7.41959 1.03162 7.28735 0.939436 7.14135 0.945574Z",
    fill: "#F5CC26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a152e99987c936a5c2660a76e6cadfef.svg";
export { ForwardRef as ReactComponent };